import React, { Component } from "react";
import { Link } from "react-router-dom";

import "./navBar.css";
import {
  Navbar,
  Nav,
  Form,
  FormControl,
  Button,
  NavLink,
  Dropdown,
  Col,
  Row,
  Container,
} from "react-bootstrap";
import Deconnexion from "../Deconnexion/Deconnexion";
import Avatar from "../Avatar/Avatar";

class Barremenu extends Component {
  constructor(props) {
    super(props);
    this.state = { compte: {} };
  }

  // Rafraîchit la liste des restaurants du compte (avec la ville) au montage,
  // pour ne pas dépendre de ce qui a été stocké au login.
  componentDidMount() {
    const token = localStorage.getItem("token");
    if (!token) return;
    fetch(process.env.REACT_APP_BACKEND_URL + "/restaurateur/restaurants", {
      headers: new Headers({ Authorization: "Bearer " + token }),
    })
      .then((r) => r.json())
      .then((list) => {
        if (!Array.isArray(list)) return;
        localStorage.setItem("restaurants", JSON.stringify(list));
        if (!localStorage.getItem("restaurantId") && list[0]) {
          localStorage.setItem("restaurantId", list[0]._id);
          localStorage.setItem("restaurantPublicId", list[0].publicId);
          localStorage.setItem("restaurantName", list[0].restaurantName);
        }
        this.setState({ restaurantsLoaded: Date.now() }); // force le re-render
      })
      .catch(() => {});

    // Récupère le compte (photo + nom) pour l'avatar du dropdown haut-droit.
    fetch(process.env.REACT_APP_BACKEND_URL + "/restaurateur/profil", {
      headers: new Headers({ Authorization: "Bearer " + token }),
    })
      .then((r) => r.json())
      .then((compte) => {
        if (compte && compte._id) this.setState({ compte });
      })
      .catch(() => {});
  }

  // Sélecteur du restaurant courant (multi-restaurants par compte).
  renderRestaurantSelector = () => {
    let restaurants = [];
    try {
      restaurants = JSON.parse(localStorage.getItem("restaurants") || "[]");
    } catch (e) {
      restaurants = [];
    }
    if (!restaurants.length) return null;
    const currentId = localStorage.getItem("restaurantId") || "";
    // Libellé : "Nom - Ville" pour distinguer les restaurants homonymes
    const label = (r) =>
      r.restaurantName + (r.city ? " - " + r.city : "");
    const current = restaurants.find((r) => r._id === currentId);
    const switchTo = (r) => {
      localStorage.setItem("restaurantId", r._id);
      localStorage.setItem("restaurantPublicId", r.publicId);
      localStorage.setItem("restaurantName", r.restaurantName);
      // Recharge pour que tous les écrans refetchent sur le nouveau resto
      window.location.reload();
    };
    return (
      <Dropdown className="nav restaurantDropdown">
        <Dropdown.Toggle variant="success" id="dropdown-restaurant">
          {current ? label(current) : "Mes restaurants"}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {restaurants.map((r) => (
            <Dropdown.Item key={r._id} onClick={() => switchTo(r)}>
              {label(r)}
            </Dropdown.Item>
          ))}
          <Dropdown.Divider />
          <Dropdown.Item onClick={this.addRestaurant}>
            + Ajouter un restaurant
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  // Crée un nouveau restaurant rattaché au compte courant.
  addRestaurant = () => {
    const name = window.prompt("Nom du nouveau restaurant ?");
    if (!name) return;
    const token = localStorage.getItem("token");
    fetch(process.env.REACT_APP_BACKEND_URL + "/restaurateur/restaurants", {
      method: "POST",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      }),
      body: JSON.stringify({ restaurantName: name }),
    })
      .then((r) => r.json())
      .then((resp) => {
        if (!resp.restaurant) return;
        // Recharge la liste complète des restaurants du compte
        fetch(process.env.REACT_APP_BACKEND_URL + "/restaurateur/restaurants", {
          headers: new Headers({ Authorization: "Bearer " + token }),
        })
          .then((r) => r.json())
          .then((list) => {
            localStorage.setItem("restaurants", JSON.stringify(list));
            localStorage.setItem("restaurantId", resp.restaurant._id);
            localStorage.setItem("restaurantPublicId", resp.restaurant.publicId);
            localStorage.setItem(
              "restaurantName",
              resp.restaurant.restaurantName
            );
            window.location.reload();
          });
      });
  };

  connect = () => {
    if (this.props.login) {
      return (
        <Container fluid>
          <Row className="partie1">
            <div className="topBarRight">
              <Dropdown className="nav justify-content-right">
                <Dropdown.Toggle
                  alignRight
                  variant="success"
                  id="dropdown-basic">
                  <Avatar
                    photo={this.state.compte.photo}
                    firstName={this.state.compte.bossFirstName}
                    lastName={this.state.compte.bossName}
                    className="navAvatar"
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="/homepage">Accueil</Dropdown.Item>
                  <Dropdown.Item href="/monCompte">Mon compte</Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      window.confirm("Voulez vous vous déconnecter ?");
                      localStorage.clear();
                      this.props.setLogin(false);
                      this.props.history.push("/");
                    }}
                    href="/">
                    Déconnexion
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              {this.renderRestaurantSelector()}
            </div>

            <Col className="logoPartie1" md={12}>
              <a href="https://tipourboire.com/">
                <img src="/image/logoJaune.png" />
              </a>
            </Col>
          </Row>
        </Container>
      );
    } else {
      return (
        <Container fluid>
          <Row className="partie1">
            <Dropdown className="nav justify-content-right">
              <Dropdown.Toggle alignRight variant="success" id="dropdown-basic">
                <img src="/image/user.png" />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="/inscription">Inscription</Dropdown.Item>
                <Dropdown.Item href="/">Connexion</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            <Col className="logoPartie1" md={12}>
              <a href="https://tipourboire.com">
                <img src="/image/logoJaune.png" />
              </a>
            </Col>
          </Row>
        </Container>
      );
    }
  };

  componentDidUpdate() {
    this.connect();
  }
  render() {
    return <div className="barre-de-menu">{this.connect()}</div>;
  }
}
export default Barremenu;
